export default __webpack_public_path__ + "static/1-36-0-preflight-7e9c90dae885d89c6a0433268940ab65.png";